import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  getCurrencyByCountry,
  getPriceByCountry,
  getDiscountByCountry,
} from "../../../helpers/countryHelper";

export default function SearchItems({ product, closeMobileMenu, setSearch }) {
  const { i18n } = useTranslation();
  const { selectedCountry } = useSelector((state) => state.country);
  const currency = getCurrencyByCountry(selectedCountry);
  const countryPrice = getPriceByCountry(product, selectedCountry);
  const countryDiscount = getDiscountByCountry(product, selectedCountry);
  const finalPrice = countryPrice - countryPrice * (countryDiscount / 100);
  return (
    <Link
      to={`/product/${product.id}`}
      onClick={() => {
        if (closeMobileMenu) closeMobileMenu();
        if (setSearch) setSearch("");
      }}
      className="d-flex py-2 align-items-start gap-2 border-bottom"
    >
      <img
        src={`${import.meta.env.VITE_REACT_APP_API_URL}/${product.img}`}
        alt="product-image"
        className="rounded-1 object-fit-cover"
        width={"75px"}
        height={"75px"}
        loading="lazy"
      />
      <div className="d-flex flex-column">
        <span className="mb-0 fw-semibold">
          {i18n?.language === "ar" ? product.name : product.name_en}
        </span>
        <span className="text-black fw-medium">
          {" "}
          {finalPrice.toFixed(2)} {currency}
        </span>
      </div>
    </Link>
  );
}
